import { ReactNode } from 'react';
import { AnimatePresence } from 'framer-motion';
import Backdrop from './Backdrop';
import { getModalVariantAnimations } from './helpers';
import { BackdropBackgroundType, ModalAnimationType, IAnimationOptions } from './types';
import * as Styles from './styles';

interface IModalWrapperProps {
  children: ReactNode;
  isVisible: boolean;
  variant?: ModalAnimationType;
  isInitialAnimation?: boolean;
  backdropBackground?: BackdropBackgroundType;
  modalWidth?: string;
  modalHeight?: string;
  className?: string;
  handleClose?: () => void;
  options?: IAnimationOptions;
  zIndex?: number;
}

const ModalWrapper = ({
  children,
  isVisible,
  variant = 'slideUpFromBottom',
  isInitialAnimation = false,
  backdropBackground = 'light',
  handleClose,
  modalWidth,
  modalHeight,
  className,
  options,
  zIndex = 1000,
}: IModalWrapperProps) => (
  <AnimatePresence initial={isInitialAnimation} mode="wait">
    {isVisible && (
      <Backdrop
        onClick={handleClose}
        backdropBackground={backdropBackground}
        options={options}
        zIndex={zIndex}
      >
        <Styles.ChildrenWrapper
          onClick={event => event.stopPropagation()}
          variants={getModalVariantAnimations(options ?? {})[variant]}
          initial="hidden"
          animate="visible"
          exit="exit"
          modalWidth={modalWidth ?? null}
          modalHeight={modalHeight ?? null}
          className={`center ${className ?? ''}`}
        >
          {children}
        </Styles.ChildrenWrapper>
      </Backdrop>
    )}
  </AnimatePresence>
);

export default ModalWrapper;
